import { ChakraProvider } from "@chakra-ui/react";
import type { AppProps } from "next/app";
import Head from "next/head";
import customTheme from "../styles/theme";
import { LiveblocksProvider } from "@liveblocks/react";

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <LiveblocksProvider
      throttle={16}
      publicApiKey={process.env.NEXT_PUBLIC_LIVEBLOCKS_PUBLIC_KEY!}
    >
      <ChakraProvider theme={customTheme} resetCSS>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
        </Head>
        <Component {...pageProps} />
      </ChakraProvider>
    </LiveblocksProvider>
  );
};

export default App;
